import { model as config, remote } from '@/config'

// indicates about enabled or disabled reset/forgot password feature
export const $resetPasswordEnabled = config.get(
  remote.tria_isResetPasswordEnabled
)
